import React from "react";
import Sound from "react-sound";
import rush from "../../../assets/audio/rush.mp3";
import ringing from "../../../assets/audio/ringing.mp3";
import chatNotification from "../../../assets/audio/chat.mp3";

export const SoundNotification = (props) => {
  const { incommingCallSoundOn, ringingSoundOn, messageSoundOn } = props;
  return (
    <>
      <Sound
        url={rush}
        loop={true}
        playStatus={
          incommingCallSoundOn ? Sound.status.PLAYING : Sound.status.STOPPED
        }
      />

      {ringingSoundOn ? (
        <Sound
          url={ringing}
          loop={true}
          playStatus={
            ringingSoundOn ? Sound.status.PLAYING : Sound.status.STOPPED
          }
        />
      ) : null}
      <Sound
        url={chatNotification}
        loop={true}
        playStatus={
          messageSoundOn ? Sound.status.PLAYING : Sound.status.STOPPED
        }
      />
    </>
  );
};
